import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import {
  DESKTOP_MIN_WIDTH,
  FEMALE,
  MALE,
  REGISTER_GENDER_NAME,
  REGISTER_PERSONAL_DETAILS_GENDER_FIELD,
} from 'constants';
import { Fade } from 'helpers/animation';
import useFormInput from 'hooks/form/useFormInput';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputGenderRadio = ({
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();

  const isMale = information[REGISTER_GENDER_NAME] === MALE;
  const isFemale = information[REGISTER_GENDER_NAME] === FEMALE;

  const {
    setInformationFormInput,
    setValidationFormInput,
    FormLabel,
    FormControlFeedback,
  } = useFormInput(REGISTER_PERSONAL_DETAILS_GENDER_FIELD);

  const handleOnChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();

    setInformationFormInput({
      value,
      information,
      setInformation,
    });

    setValidationFormInput({
      validation,
      setValidation,
      isReset: true,
    });
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 = REGISTER_GENDER_NAME + '1';
    return (
      <FormCheckboxRadio
        name={REGISTER_GENDER_NAME}
        className={`${formCheckRadioClassName1} ${isMale ? 'active' : ''}`}
        label={t('form_gender_male')}
        isChecked={isMale}
        isInvalid={validation[REGISTER_GENDER_NAME]}
        onClick={(e) => handleOnChange(e, MALE)}
      />
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 = REGISTER_GENDER_NAME + '2';
    return (
      <FormCheckboxRadio
        name={REGISTER_GENDER_NAME}
        className={`${formCheckRadioClassName2} ${isFemale ? 'active' : ''}`}
        label={t('form_gender_female')}
        isChecked={isFemale}
        isInvalid={validation[REGISTER_GENDER_NAME]}
        onClick={(e) => handleOnChange(e, FEMALE)}
      />
    );
  };

  return (
    <FormGroupStyled>
      <FormLabel />
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
      <FormControlFeedback value={t(validation[REGISTER_GENDER_NAME])} />
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 32px;
  position: relative;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 34px;
  }
`;

export default FormInputGenderRadio;
